// @flow

// using this list as starting point: https://practicaltypography.com/common-accented-characters.html
const ACCENT_MAP = {
  á: 'a',
  à: 'a',
  â: 'a',
  ä: 'a',
  ã: 'a',
  å: 'a',
  æ: 'a',
  ç: 'c',
  é: 'e',
  è: 'e',
  ê: 'e',
  ë: 'e',
  í: 'i',
  ì: 'i',
  î: 'i',
  ï: 'i',
  ñ: 'n',
  ó: 'o',
  ò: 'o',
  ô: 'o',
  ö: 'o',
  õ: 'o',
  ø: 'o',
  œ: 'o',
  ß: 's',
  ú: 'u',
  ù: 'u',
  û: 'u',
  ü: 'u',
};

// Source: http://alistapart.com/article/accent-folding-for-auto-complete
const accentFoldedToken: (token: string) => string = (token) => {
  if (!token) {
    return '';
  }
  let ret = '';
  for (let i = 0; i < token.length; i += 1) {
    ret += ACCENT_MAP[token.charAt(i)] || token.charAt(i);
  }

  return ret;
};

// Returns true if each token in the query matches a (in-order) token in the name string
export const compareTokenizedNameWithQuery: (name: string, query: string) => boolean = (
  name,
  query,
) => {
  const tokenizedQuery = query.split(' ');
  const tokenizedBoardName = name.split(' ');
  let queryIndex = 0;
  for (let i = 0; i < tokenizedBoardName.length; i += 1) {
    const accentFolded = accentFoldedToken(tokenizedBoardName[i]);

    // We don't want to accent fold the tokenizedQuery because the searched for specific accent could be important
    if (
      accentFolded.includes(tokenizedQuery[queryIndex]) ||
      tokenizedBoardName[i].includes(tokenizedQuery[queryIndex])
    ) {
      queryIndex += 1;
    }
  }

  return queryIndex === tokenizedQuery.length;
};

// Returns the filtered list of items with filterKey value that match the query
export const filterItemsByQuery: (
  // $FlowFixMe Flow v0.104.0 upgrade supression.
  items: Array<*>,
  query: string,
  filterKey?: string,
  // $FlowFixMe Flow v0.104.0 upgrade supression.
) => Array<*> = (items, query, filterKey = 'name') => {
  const rawQueryForComparison = query.toLowerCase();
  return items.filter((item) =>
    compareTokenizedNameWithQuery(item[filterKey].toLowerCase(), rawQueryForComparison),
  );
};
